import React from 'react';
import PropTypes from 'prop-types';

import InsertFieldsContainer from '../containers/InsertFieldsContainer';
import Dialog from '../../shared/components/Dialog';
import Spinner from '../../shared/components/Spinner';
import Alert from '../../shared/components/Alert';
import {FormattedMessage, injectIntl} from 'react-intl';
import Banners from '../../shared/components/Banners';

const TicketCreateConfirmDialog = ({
  createdTicket: {TicketNumber, StoreOrderTemplates},
  intl,
  goToTicket,
  goToStoreOrder,
  cancel
}) => (
  <Dialog
    className="new-ticket-confirm"
    title={intl.formatMessage({id: 'tickets.insert_forms_saved'})}
    size="small"
    showCancel={false}
    extraButton={StoreOrderTemplates.length > 0 ? null : {
      label: intl.formatMessage({
        id: 'tickets.insert_forms_go_to_ticket'
      }),
      icon: 'eye-open',
      onClick: goToTicket
    }}
    onConfirm={StoreOrderTemplates.length > 0 ? goToStoreOrder : cancel}
    confirmIcon={StoreOrderTemplates.length > 0 ? 'shopping-cart' : 'home'}
    confirmLabel={StoreOrderTemplates.length > 0 ? intl.formatMessage({
      id: 'tickets.insert_forms_go_to_store_order'
    }) : intl.formatMessage({
      id: 'tickets.insert_forms_saved_close'
    })}>
    <FormattedMessage
      id="tickets.insert_forms_saved_message"
      values={{ticketnumber: TicketNumber}}
    />
  </Dialog>
);
TicketCreateConfirmDialog.propTypes = {
  createdTicket: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  goToTicket: PropTypes.func.isRequired,
  goToStoreOrder: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

// Ticket creation page
const TicketInsertForm = ({
  createdTicket,
  showCancel,
  hideCancel,
  confirmCancel,
  goToTicket,
  goToStoreOrder,
  cancel,
  error,
  submitting,
  intl,
  ...otherProps
}) => (
  <div
    title={intl.formatMessage({id: 'tickets.insert_forms_title'})}
    className="new-ticket">
    {submitting && <Spinner loadingText="Saving Work Order..." />}
    <Banners
      banners={otherProps.currentUser.ParentAccount.BannerConfig}
      where={x => x.IsNewWorkOrderScreen && x.IsBottom === false}
      type="error"
    />
    <InsertFieldsContainer {...otherProps} />
    <Banners
      banners={otherProps.currentUser.ParentAccount.BannerConfig}
      where={x => x.IsNewWorkOrderScreen && x.IsBottom}
      type="error"
    />

    <Alert error={error} />
    {showCancel && (
      <Dialog
        className="new-ticket-cancel"
        title={intl.formatMessage({id: 'tickets.insert_forms_cancel'})}
        size="small"
        confirmLabel={intl.formatMessage({
          id: 'tickets.insert_forms_confirm_cancel'
        })}
        onDismiss={hideCancel}
        onConfirm={cancel}>
        {intl.formatMessage({id: 'tickets.insert_forms_on_confirm_cancel'})}
      </Dialog>
    )}
    {createdTicket && (
      <TicketCreateConfirmDialog
        createdTicket={createdTicket}
        intl={intl}
        goToTicket={goToTicket}
        goToStoreOrder={goToStoreOrder}
        cancel={cancel}
      />
    )}
  </div>
);

TicketInsertForm.propTypes = {
  // show the confirmation dialog for cancel
  confirmCancel: PropTypes.func.isRequired,
  hideCancel: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  goToStoreOrder: PropTypes.func.isRequired,
  goToTicket: PropTypes.func.isRequired,
};

export default injectIntl(TicketInsertForm);
